export const FETCH_REAL_POWER_REQUEST = '[RealPowerVsTemperature] FETCH_REAL_POWER_REQUEST';
export const FETCH_REAL_POWER_SUCCESS = '[RealPowerVsTemperature] FETCH_REAL_POWER_SUCCESS';
export const FETCH_REAL_POWER_FAILURE = '[RealPowerVsTemperature] FETCH_REAL_POWER_FAILURE';
